import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const SearchInput = ({ query, setQuery, onFocus, onKeyDown }) => {
    return (
        <>
            <SearchOutlinedIcon />
            
            <input
                type="text"
                placeholder="Search..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onFocus={onFocus}
                onKeyDown={onKeyDown} 
            />
        </>
    );
};

export default SearchInput;